import { useReactiveVar } from '@apollo/client';
import Checkbox from '@mui/material/Checkbox';
import type React from 'react';
import styles from 'src/components/SelectCheckBox/SelectCheckBoxStyles';
import viewStateVar from 'src/store/viewState';

interface SelectCheckboxProps {
  absolutePosition?: boolean;
  itemId: string;
}

const SelectCheckbox: React.FC<SelectCheckboxProps> = ({ absolutePosition, itemId }) => {
  const classes = styles();
  const { selectedAssets } = useReactiveVar(viewStateVar);
  const isChecked = selectedAssets.includes(itemId);

  const handleChange = (): void => {
    if (isChecked) {
      viewStateVar({
        ...viewStateVar(),
        selectedAssets: viewStateVar().selectedAssets.filter((asset: string) => asset !== itemId),
      });
    } else {
      viewStateVar({
        ...viewStateVar(),
        selectedAssets: [...viewStateVar().selectedAssets, itemId],
      });
    }
  };

  return (
    <div className={absolutePosition ? classes.absolutePosition : ''}>
      <Checkbox checked={isChecked} onChange={handleChange} />
    </div>
  );
};

export default SelectCheckbox;
